import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettlLawSuitModelSelectLayer extends BasePopUpLayer {

    @property(cc.Node)
    nodeSelect: cc.Node = null;

    private curSelectIdx = -1;
    
    start(){
        O1HD.on(MessageEventKind.EventName.LEVEL_JUDGE, this.levelJudge, this);
        
        this.initLayer();

        O1HD.getModules().uiControlModule.hideLoading();
        this.levelJudge();
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.GOVERNMENT);
    }

    levelJudge() {
        utilsView.enterLayerDispose(UIKind.UILayerTag.GOVERNMENT, this.node);
    }
    
    //加载
    initLayer(){
        this.nodeSelect.children.forEach((v, i)=> {
            v.getChildByName('light').active = false;
            v.on("touchstart", this.onBtnClickStart, this);
            v.on("touchend", (event: cc.Event.EventTouch)=> {
                this.curSelectIdx = i;
                this.selectButtonLight(v);
                if (i == 0) {
                    this.onClickCivil();
                } else if (i == 1) {
                    this.onClickArrestCriminal();
                }
                this.onBtnClickCancel(event);
            }, this);
            v.on("touchcancel", this.onBtnClickCancel, this);
        });
    }

    onBtnClickStart(event: cc.Event.EventTouch) {
        let tNode = event.getCurrentTarget();
        tNode.getChildByName('light').active = true;
    }

    selectButtonLight(node: cc.Node) {
        this.nodeSelect.children.forEach((v, i)=> {
            if (node == v) {
                return;
            }
            v.getChildByName('light').active = false;
        });
    }

    onClickCivil() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SettlLawSuitSelectLayer
            , null 
            , {
                csvFile: CsvFileKind.CsvFile.LEGAL_CASE_MAIN
                , prefab: FileKind.PrefabFilePath.SettleLawsuitMainLayer
            }
        );
        // utilsView.openPopupLayerTwo(
        //     FileKind.PrefabFilePath.SettleLawsuitPrimaryLayer
        //     , null
        //     , {}
        // );
    }

    onClickArrestCriminal() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SettlLawSuitSelectLayer
            , null 
            , {
                csvFile: CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY
                , prefab: FileKind.PrefabFilePath.SettleLawsuitPrimaryLayer
            }
        );

        // utilsView.openPopupLayerTwo(
        //     FileKind.PrefabFilePath.SettleLawsuitMainLayer
        //     , null
        //     , {}
        // );
    }
    
    onBtnClickCancel(event: cc.Event.EventTouch) {
        let tNode = event.getCurrentTarget();
        tNode.getChildByName('light').active = false;
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // this.curSelectIdx
        // utilsView.openPopupLayerTwo(
        //     FileKind.PrefabFilePath.SettleLawsuitAttackLayer
        //     , null
        //     , {}
        // );
    }

    onClickAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            
        },()=>{

        },null,"断案观看广告刷新列表")
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }
}
